<template>
    <div class="stripe-reader-cta-container mt-4">
        <submit-button
            v-if="!isDeviceConnected || !(discoveredReaders && connectedReader)"
            :processing="isConnectingToReader"
            color="green"
            @click="readerHandler"
            v-text="readerBtnCopy"/>
        <p v-if="discoveredReaders || connectedReader" v-text="readerCopy"></p>
        <p v-if="cardNumber" v-text="$t('CARD_DETAILS', {lastFourDigits: cardNumber})"></p>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import UserService from '@/services/users/UserService';

export default {
    name: 'StripeTerminalReader',
    components: {
        SubmitButton,
    },
    data() {
        return {
            loading: false,
            processing: false,
            stripeTerminal: null,
        };
    },
    computed: {
        ...mapGetters({
            discoveredReaders: 'canvasser/getDiscoveredReaders',
            isConnectingToReader: 'canvasser/isConnectingToReader',
            connectedReader: 'canvasser/getConnectedReader',
            connectionStatus: 'canvasser/getConnectionStatus',
            readerName: 'canvasser/getReaderName',
            cardDetails: 'canvasser/getCardDetails',
            isCanvasser: 'auth/isCanvasser',
        }),
        readerBtnCopy() {
            return !this.discoveredReaders ? this.$t('DISCOVER_READER') : this.$t('CONNECT_READER');
        },
        readerCopy() {
            return this.connectedReader ? `Connected to: ${this.readerName}` : `Device Found: ${this.readerName}`;
        },
        isDeviceConnected() {
            return this.connectionStatus && (this.connectionStatus.toLowerCase() === 'connected');
        },
        cardNumber() {
            return this.cardDetails?.payment_method?.card?.last4;
        },
    },
    mounted() {
        !this.isDeviceConnected && this.isCanvasser && this.initialiseStripeSDK();
    },
    methods: {
        ...mapActions({
            discoverReaderHandler: 'canvasser/discoverStripeTerminalReader',
            connectReaderHandler: 'canvasser/connectReaderHandler',
            collectCardDetails: 'canvasser/collectCardDetails',
        }),
        async fetchStripeTerminalToken() {
            let service = new UserService();
            let stripeTerminalToken = await service.fetchStripeTerminalToken();
            return stripeTerminalToken.data.secret;
        },
        unexpectedDisconnect() {
            this.discoverReaderHandler();
        },
        initialiseStripeSDK() {
            this.stripeTerminal = StripeTerminal.create({
                onFetchConnectionToken: this.fetchStripeTerminalToken,
                onUnexpectedReaderDisconnect: this.unexpectedDisconnect,
            });
            this.$store.commit('canvasser/setConnectionStatus', this.stripeTerminal.connectionStatus);
            this.$store.commit('canvasser/setStripeTerminal', this.stripeTerminal);
        },
        readerHandler() {
            return !this.discoveredReaders ? this.discoverReaderHandler() : this.connectReaderHandler();
        },
    },
    watch: {
        connectionStatus: {
            handler: function(connectionStatus) {
                if (connectionStatus === 'not_connected') {
                    this.initialiseStripeSDK();
                    this.$store.commit('canvasser/setDiscoveredReaders', null);
                    this.$store.commit('canvasser/setConnectedReader', null);
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
    .stripe-reader-cta-container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>
